import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { OsUpdate } from '@era/osupdates-sdk';

export interface LocationAllowedOsUpdate extends OsUpdate {
  locationId: string;
}

export type LocationAllowedOsUpdateState = EntityState<LocationAllowedOsUpdate>;

export function selectId(update: LocationAllowedOsUpdate) {
  return `${update.locationId}-${update.productKey}-${update.version}`;
}

export const adapter: EntityAdapter<LocationAllowedOsUpdate> = createEntityAdapter<LocationAllowedOsUpdate>({
  selectId,
});

export const initialState: LocationAllowedOsUpdateState = adapter.getInitialState();
